/* photo-gallery-nav.js
 * Menu d'ancres auto vers les sections « Galerie photo » de la page.
 * Sticky piloté en JS (position: fixed au scroll) — robuste face à un parent
 * en overflow. Le décalage du haut suit DYNAMIQUEMENT la hauteur du header du
 * thème (qui varie selon la largeur : 1 ou 2 lignes), + une marge réglable.
 */
(function () {
  var sticky = null;

  // Hauteur visible du header du thème (0 s'il a défilé hors écran)
  function headerOffset() {
    var h = document.querySelector('.site-header')
         || document.querySelector('.header-section')
         || document.querySelector('header');
    return h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
  }

  function buildMenu(nav) {
    var extra = parseInt(nav.getAttribute('data-extra-offset') || '0', 10);
    nav.innerHTML = '';
    document.querySelectorAll('.js-photo-gallery').forEach(function (g) {
      var wrap = g.closest('[id^="shopify-section-"]');
      if (!wrap) return;
      var title = (g.getAttribute('data-title') || '').trim();
      if (!title) return;
      var a = document.createElement('a');
      a.className = 'photo-gallery-nav__btn';
      a.href = '#' + wrap.id;
      a.textContent = title;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var y = wrap.getBoundingClientRect().top + window.pageYOffset - (headerOffset() + extra);
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
      nav.appendChild(a);
    });
    nav.style.display = nav.children.length ? '' : 'none';
  }

  function teardownSticky() {
    if (!sticky) return;
    window.removeEventListener('scroll', sticky.update);
    window.removeEventListener('resize', sticky.update);
    sticky.unpin();
    if (sticky.placeholder.parentNode) sticky.placeholder.parentNode.removeChild(sticky.placeholder);
    sticky = null;
  }

  function setupSticky(nav) {
    teardownSticky();
    var wrap = nav.closest('.photo-gallery-nav-wrap');
    if (!wrap) return;
    if (nav.getAttribute('data-sticky') !== 'true' || !nav.children.length) return;

    var extra = parseInt(nav.getAttribute('data-extra-offset') || '0', 10);
    var placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';
    wrap.parentNode.insertBefore(placeholder, wrap);
    var pinned = false;

    function pin(top) {
      placeholder.style.height = wrap.offsetHeight + 'px';
      placeholder.style.display = '';
      wrap.style.position = 'fixed';
      wrap.style.top = top + 'px';
      wrap.style.left = '0';
      wrap.style.right = '0';
      wrap.style.zIndex = '20';
      pinned = true;
    }
    function unpin() {
      wrap.style.position = '';
      wrap.style.top = '';
      wrap.style.left = '';
      wrap.style.right = '';
      wrap.style.zIndex = '';
      placeholder.style.display = 'none';
      pinned = false;
    }
    function update() {
      var top = headerOffset() + extra;                       // suit la hauteur réelle du header
      var base = (pinned ? placeholder : wrap).getBoundingClientRect().top + window.pageYOffset;
      var shouldPin = window.pageYOffset + top >= base;
      if (shouldPin) {
        if (!pinned) pin(top);
        else wrap.style.top = top + 'px';                     // réajuste si le header change de hauteur
      } else if (pinned) {
        unpin();
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    sticky = { update: update, placeholder: placeholder, unpin: unpin };
  }

  function build() {
    var nav = document.querySelector('.photo-gallery-nav');
    if (!nav) { teardownSticky(); return; }
    buildMenu(nav);
    setupSticky(nav);
  }

  document.addEventListener('DOMContentLoaded', build);
  document.addEventListener('shopify:section:load', build);
  document.addEventListener('shopify:section:unload', build);
  document.addEventListener('shopify:section:reorder', build);
})();
